module.exports = __webpack_public_path__ + "img/13.f86bbcb5.jpg";